import React from 'react';

const TypingIndicator = ({ avatar }) => (
  <div className="flex items-center space-x-2">
      <div className="avatar">
      <img src={avatar} alt="Avatar" />
      </div>
      <div className="typing-indicator">
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
        <span className="typing-dot"></span>
      </div>
    </div>
  );

export default TypingIndicator;